import { radioAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { defineStyle } from "@chakra-ui/react";
import {
  Box,
  RadioGroup,
  AspectRatio,
  ComponentStyleConfig,
  Radio as ChakraUIRadio,
  RadioProps as ChakraUIRadioProps
} from "@chakra-ui/react";

import { Image } from "../image/image";

const { definePartsStyle } = createMultiStyleConfigHelpers(radioAnatomy.keys);

const surveyLabel = defineStyle({
  fontSize: "0.875rem",
  lineHeight: "133%",
  fontWeight: "normal",
  color: "gray.700"
});

const sizes = {
  lgIconMDFont: definePartsStyle({
    control: { w: 5, h: 5 },
    label: { fontSize: "md" }
  }),
  lgIconWithLabelStyle: definePartsStyle({
    control: { w: 5, h: 5 },
    label: surveyLabel,
    icon: { fontSize: "xs" }
  }),
  mdIconWithLabelStyle: definePartsStyle({
    control: defineStyle({ w: 4, h: 4 }),
    label: surveyLabel,
    icon: { fontSize: "2xs" }
  }),
  xlIconWithLabelStyle: definePartsStyle({
    control: defineStyle({ w: 6, h: 6 }),
    label: { ...surveyLabel, mt: 1 },
    icon: { fontSize: "sm" },
    container: { alignItems: "flex-start" }
  })
};

const RadioComponentStyle: ComponentStyleConfig = {
  parts: ["control", "label", "container"],
  sizes
};

export interface RadioProps extends ChakraUIRadioProps {
  imageSrc?: string;
  imageAlt?: string;
  imageMinW?: number;
}

function Radio(props: RadioProps) {
  const { imageSrc, imageAlt, ...rest } = props;

  if (imageSrc) {
    return (
      <Box maxW="36rem">
        {imageSrc && (
          <AspectRatio ratio={16 / 9} mb={2}>
            <Image
              src={imageSrc}
              alt={imageAlt}
              aria-hidden="true"
              magnify={true}
              h="100%"
              w="100%"
            />
          </AspectRatio>
        )}
        <ChakraUIRadio {...rest} />
      </Box>
    );
  }

  return (
    <Box maxW="36rem">
      <ChakraUIRadio {...rest} />
    </Box>
  );
}

export { Radio, RadioGroup, RadioComponentStyle };
